import React, { Component } from 'react';
import { connect } from "react-redux";
import ParameterFuture from 'effects/ParameterFuture.js';
import {updateParameter} from 'operations/actions.js';
import Dropdown from 'react-dropdown';
import ResolutionDropdown from './ResolutionDropdown.js';
import Resolution from 'engine/Resolution.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import {UP, DOWN, UP_DOWN, DOWN_UP} from 'effects/midi/constants.js';

class ArpEffectComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effect: props.effect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.effect = nextProps.effect;
        return true;
    }

    handleOptionChange(evt) {
        this.setState(this.state);
    }

    handleParameterChange(parameter, value) {
        if (this.props.automation) {
            let parameterFuture = this.props.automation.get(parameter);
            if (parameterFuture === undefined) {
                this.props.automation.set(this.props.parameter, 
                    new ParameterFuture(this.props.effectNumber, parameter, value));
            } else {
                parameterFuture.value = value;
            }
        } else {
            this.props.sequencerEngine.operationManager.dispatch(
                updateParameter(parameter, value));
        }
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.effect.isEnabled();
    }

    getParameter(parameter) {
        let value = parameter.get();
        if (this.props.automation) {
            let automationValue = this.props.automation.get(parameter);
            if (automationValue !== undefined) {
                return automationValue.value;
            }
        }
        return value;
    }

    render() {
        return (
            <div>
              {!this.isEnabled() ? '' :
                  <div>
                        <ResolutionDropdown
                              automation={this.props.automation}
                              onChange={(v) => this.handleParameterChange(this.state.effect.arpRateParameter, v)}
                              parameter={this.state.effect.arpRateParameter}/>
                        <div className="lfo-rate-dropdown">
                              <div className="lfo-rate-label">
                                    Direction:
                                  </div>
                                  <Dropdown
                                        className='osc-type-dropdown'
                                        controlClassName='osc-type-control-dropdown'
                                        arrowClassName='osc-type-arrow-dropdown'
                                        options={directionOptions}
                                        onChange={(o) => this.handleParameterChange(this.state.effect.arpDirectionParameter, o.value)}
                                        value={getArpDirectionOption(this.getParameter(this.state.effect.arpDirectionParameter))}
                                        placeholder="Direction" />
                                        <div className="clear-fix"/>


                            </div>
                       <EffectParameterSlider
                           effectNumber={this.props.effectNumber}
                             automation={this.props.automation}
                           name={'Octaves'}
                           parameter={this.state.effect.arpOctavesParameter}
                           onParameterChanged={this.props.onParameterChanged}
                           isParameter={true}
                           sequencerEngine={this.props.sequencerEngine}
                           lfoEnabled={true}
                           step={1}
                           min={0}
                           max={6}/>
                       <EffectParameterSlider
                           effectNumber={this.props.effectNumber}
                           automation={this.props.automation}
                           name={'Repeats'}
                           parameter={this.state.effect.arpRepeatParameter}
                           onParameterChanged={this.props.onParameterChanged}
                           isParameter={true}
                           sequencerEngine={this.props.sequencerEngine}
                           lfoEnabled={true}
                           step={1}
                           min={1}
                           max={8}/>
                       <EffectParameterSlider
                           effectNumber={this.props.effectNumber}
                           automation={this.props.automation}
                           name={'Duration Factor'}
                           parameter={this.state.effect.arpDurationFactorParameter}
                           onParameterChanged={this.props.onParameterChanged}
                           isParameter={true}
                           sequencerEngine={this.props.sequencerEngine}
                           lfoEnabled={true}
                           step={0.1}
                           min={0.1}
                           max={8}/>
                  </div>} 
            </div>
        );
    }
}

const directionOptions = [
    {value: DOWN, label:'Down'},
    {value: UP, label:'Up'}
];

function getArpDirectionOption(value) {
    return directionOptions.filter(
        option => option.value === value)[0];
}

const mapStateToProps = (state, props) => {
    return {
        arpDirection: props.effect.arpDirectionParameter.get(),
        isMacroMapping: state.effects.isMacroMapping,
    };
};

export default connect(mapStateToProps, null)(ArpEffectComponent);
